<template>
  <div class="partner_page page">
    <div class="top_bg">
      <img :src="banner?api+banner:require('../assets/download_bg.png')">
    </div>

    <b-container class="partner_content my_content">
      <p class="title">{{ title }}</p>

      <div class="tabs">
        <div class="tab" v-for="(item,index) in tabsList" :class="{'active':currentTab === item.id}"
             @click="switchTab(item.id)" :key="index">
          <div class="box_inner" v-if="index === 0 || ((index === tabsList.length-1) && index > 0)">
            {{ item.name }}
          </div>
          <span v-if="index > 0 && (index < tabsList.length-1)">{{ item.name }}</span>
        </div>
      </div>

      <div class="content">
        <transition name="fade">
          <b-row v-if="partnersList.length">
            <b-col md="4" v-for="item in partnersList" :key="item.id"
                   style="margin-bottom: 30px;cursor: pointer"
                   @click="itemClick(item.url)">
              <div class="text-center logo_box">
                <img :src="api+item.logoFile" class="logo_img">
              </div>
              <p class="name">{{ item.name }}</p>
              <p class="address">{{ item.title }}</p>
              <p class="phone"><img src="../assets/phone.png" width="16">{{ item.phone }}</p>
              <p class="email"><img src="../assets/email.png" width="16">{{ item.email }}</p>
            </b-col>
          </b-row>
        </transition>

      </div>


    </b-container>
  </div>
</template>

<script>
import {getPartners, getTypeList} from '../api/HomeService'
import {api} from '../api/api';

export default {
  name: "Partner",
  data() {
    return {
      tabsList: [
        {id: 0, name: "全部"},
      ],
      currentTab: 0,
      languageNum: window.localStorage.getItem("languageNum"),
      partnersList: [],
      api: api,
      title: '',
      banner: ''
    }
  },
  methods: {

    itemClick(url) {
      window.open(url)
    },

    switchTab(tabId) {
      this.currentTab = tabId
      this.partnersList = []
      this.getPartnersList()
    },

    getTypeList() {
      let sendData2 = {
        languageNum: this.languageNum,
        classType: 7
      }
      getTypeList(sendData2, data => {
        this.tabsList = this.tabsList.concat(data)
        console.log(this.tabsList)
      })
    },

    getPartnersList() {
      let sendData = {
        languageNum: this.languageNum,
        // type: this.currentTab
      }

      if (this.currentTab) {
        sendData.type = this.currentTab;
      }

      getPartners(sendData, data => {
        this.partnersList = data
      })
    }

  },
  mounted() {
    let menuList = JSON.parse(window.localStorage.getItem('menuList'));
    for (let i = 0; i < menuList.length; i++) {
      if (menuList[i].children) {
        for (let j = 0; j < menuList[i].children.length; j++) {
          if (this.$route.path.indexOf(menuList[i].children[j].menuUrl) > 0) {
            this.title = menuList[i].children[j].title
            this.banner = menuList[i].children[j].banner
          }
        }
      }
    }
    this.getTypeList();
    this.getPartnersList()
  }
}
</script>

<style scoped lang="scss" src="../css/partner.scss">

</style>